export default "__VITE_ASSET__Cuvhgk3z__"